module.exports = __webpack_public_path__ + "static/media/los-angeles-our-rigorous.d2aab388.jpg";